import React from 'react';
import './results.scss';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';

const Results: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className="results">
            <h1 className="results__title">Fantastic, let’s take a moment to go over your results together.</h1>
            <h4 className="results__subtitle">We're here to guide you through what these findings indicate and explore the steps you can take next.</h4>
            <Button type='primary' onPressed={() => { navigate('/result-score', { replace: true }); }} >
                {'View results'}
            </Button>
        </div>
    );
}

export default Results;
